import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ children, requiredPermission }) => {
  const { isAuthenticated, user } = useSelector((state) => state.auth);

  const permissions = user?.user?.permissions || [];

  const sessionFlag = sessionStorage.getItem("hrmsLogin") === "true";
  const persistedAuth = localStorage.getItem("isAuthenticated") === "true";

  // NOT AUTHENTICATED
  if (!sessionFlag && !persistedAuth && !isAuthenticated) {
    return <Navigate to="/signin" replace />;
  }

  // NOT AUTHORIZED (if requiredPermission is specified)
  if (requiredPermission) {
    const hasAccess = Array.isArray(requiredPermission)
      ? requiredPermission.some((p) => permissions.includes(p))
      : permissions.includes(requiredPermission);

    if (!hasAccess) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;